import { render, staticRenderFns } from "./certificateDetail.vue?vue&type=template&id=4afb59a8&scoped=true&"
import script from "./certificateDetail.vue?vue&type=script&lang=js&"
export * from "./certificateDetail.vue?vue&type=script&lang=js&"
import style0 from "./certificateDetail.vue?vue&type=style&index=0&id=4afb59a8&lang=scss&scoped=true&"
import style1 from "./certificateDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afb59a8",
  null
  
)

export default component.exports